/** @format */
import { css } from 'styled-components';

import { ProductTrustCardVariant } from './types';

export const getProductTrustCardVariantStyles = (
    variant?: ProductTrustCardVariant
) => {
    switch (variant) {
        case ProductTrustCardVariant.SUN:
            return css`
                background: var(--colors-surface-accent-subtle);
                border: 1px solid var(--colors-border-accent);

                .product-trust-card-icon {
                    border: 1px solid var(--colors-border-secondary);
                }
            `;
        case ProductTrustCardVariant.WHITE:
        default:
            return css`
                background: var(--colors-surface-primary);
                border: 1px solid var(--colors-border-light);

                .product-trust-card-icon > svg {
                    width: var(--layout-spacing-16);
                }
            `;
    }
};
